<template>
  <div
    class="enter-otp text-center"
    :class="{ 'safety-assistant': safetyAssistant }"
  >
    <h3 class="mt-2 mb-2">{{ $t('enterOtp.title') }}</h3>
    <div class="mb-7 identifier">
      <span>{{ emailIdentifier || phoneIdentifier }}</span>
    </div>
    <p class="mb-4">{{ $t('enterOtp.enterCode') }}</p>
    <v-otp-input
      ref="otpInput"
      v-model="otpToken"
      class="mb-5 code-input"
      plain
      length="6"
      inputmode="tel"
      :disabled="loading"
      sls-element-id="login-input-otp"
      @finish="submit"
    ></v-otp-input>
    <PrimaryButton
      class="mb-5"
      :disabled="loading || !isValidOtp"
      :click="submit"
      sls-element-id="login-button-verify"
      >{{ $t('common.verify') }}</PrimaryButton
    >
    <div
      class="mt-6 footer-link"
      sls-element-id="login-link-back"
      @click="back"
    >
      {{ $t('enterOtp.backToPassword') }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import PrimaryButton from '@/components/common/PrimaryButton'

export default {
  components: {
    PrimaryButton,
  },
  data() {
    return {
      otpToken: null,
    }
  },
  computed: {
    ...mapState({
      loading: 'loading',
      emailIdentifier: 'emailIdentifier',
      phoneIdentifier: 'phoneIdentifier',
    }),
    ...mapGetters({
      safetyAssistant: 'safetyAssistant',
    }),
    isValidOtp() {
      return /^\d{6}$/.test(this.otpToken)
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.otpInput) {
        this.$refs.otpInput.focus()
      }
    })
  },
  methods: {
    ...mapActions({
      verifyOtp: 'verifyOtp',
      setStage: 'setStage',
    }),
    back() {
      this.otpToken = null
      this.setStage('userIdentifier')
    },
    async submit() {
      if (this.isValidOtp) {
        try {
          await this.verifyOtp({ otpToken: this.otpToken })
        } finally {
          this.otpToken = null
        }
      }
    },
  },
}
</script>
<style scoped lang="sass">
.enter-otp
  .identifier
    display: flex
    font-size: 16px
    color: $black
    font-weight: 500
    cursor: pointer
    justify-content: center
    span
      overflow: hidden
      text-overflow: ellipsis
      display: block
      max-width: 100%
      white-space: nowrap
      padding-right: 6px
  .code-input
    background-color: $white
    border: 1px solid $darkBlue
    border-radius: 5px
    padding: 2px 24px
    width: 250px
    margin: auto

.theme--dark
  h3
    color: $white !important
  .identifier
    span
      color: $white !important
  p
    color: $textMuted !important
  .footer-link
    color: $darkBlue !important
  .code-input
    background-color: $darkBackground !important
    border-color: $darkBorder !important
    ::v-deep input
      color: $white !important
      caret-color: $white !important
  ::v-deep .v-otp-input
    .v-input
      &:not(.v-input--has-state)
        .v-input__slot
          &:before
            border-color: $darkBorder !important
          &:hover:before
            border-color: $darkBorderHover !important
      &.v-input--is-focused
        .v-input__slot
          &:after
            border-color: $darkBlue !important

.safety-assistant
  h3
    color: $white !important
  .identifier
    span
      color: $textLight !important
  p
    color: $textLight !important
  .footer-link
    color: $primaryBlue !important
  .code-input
    background-color: $darkInputBg !important
    border-color: $darkBorder !important
    color: $white !important
    ::v-deep input
      color: $white !important
      caret-color: $white !important
  ::v-deep .v-otp-input
    .v-input
      &:not(.v-input--has-state)
        .v-input__slot
          &:before
            border-color: $whiteOpacity42 !important
          &:hover:before
            border-color: $darkBorderFocus !important
      &.v-input--is-focused
        .v-input__slot
          &:after
            border-color: $primaryBlue !important
</style>
